export default "__VITE_ASSET__BoZQ4PI1__"